import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckSquare = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "check-square" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6.75,9l3.294,4.611a1.526,1.526,0,0,0,2.414.09L23.25.749"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.75,10.5v9.75a3,3,0,0,1-3,3h-15a3,3,0,0,1-3-3v-15a3,3,0,0,1,3-3H16.5"
		})
	]
});
export default SvgCheckSquare;
